import React, { useState } from "react";
import { Container, CardHeader, Card, CardBody, Spinner } from "reactstrap";
import { VerifyUser, apiError } from "../../slices/thunks";
import { useLocation, useNavigate } from "react-router-dom";
import sebiIcon from "../../assets/images/sebi-logo.png";
import { useDispatch } from "react-redux";
import axios from "axios";
import { showToast } from "../../Components/ToastNotification";
import { loginSuccess } from "../../slices/auth/login/reducer";
import { addPersistLoginInfo } from "../../slices/PersistData/reducer";
import { set } from "lodash";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";

const RiskDisclosure = () => {
  document.title = "Risk disclosures | B.N. Rathi";

  const disclosures = [
    {
      text: "9 out of 10 individual traders in equity Futures and Options Segment, incurred net losses.",
    },
    {
      text: "On an average, loss makers registered net trading loss close to ₹50,000.",
    },
    {
      text: "Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.",
    },
    {
      text: "Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.",
    },
  ];

  const sebiLink =
    "https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { userData } = usePersistStoreData();
  const token = userData?.token;

  const rawHash = location.search;
 
  // loading state for sso route
  const [loading, setLoading] = useState(false);

  // loading state for desktop route
  const [verifyLoading, setVerifyLoading] = useState(false);

  // handle sso route
  const fetchSSO_token = async () => {
    setLoading(true);
    try {
      const data = await axios.post(
        "/get-token",
        {},
        {
          params: { sso_token: rawHash },
          headers: { Accept: "application/json" },
        }
      );

      if (data?.code === 200) {
        setLoading(false);
        // store login session
        sessionStorage.setItem("authUser", JSON.stringify(data));
        sessionStorage.setItem("welcomeModalShown", "true");
        // redux updates
        dispatch(loginSuccess(data));
        dispatch(addPersistLoginInfo(data));
        navigate("/dashboard");
      } else {
        navigate("/login");
        showToast(data?.message || "Something went wrong", "error");
        dispatch(apiError(data));
        setLoading(false);
      }

      return data;
    } catch (error) {
      dispatch(apiError(error));
      showToast("Error fetching report. Please try again.", "error");
      navigate("/login");
      setLoading(false);
      return error;
    }
  };

  const handleContinue = () => {
    
    if (token && !rawHash) {
      navigate("/dashboard");
      // dispatch(VerifyUser({ user: userData, token }))
      //   .then((res) => {
      //     if (res?.code === 200) {
      //       setVerifyLoading(false);
      //       navigate("/dashboard");
      //     }
      //   })
      //   .catch(() => {
      //     setVerifyLoading(false);
      //   });
    } else {
      fetchSSO_token();
    }
  };

  return (
    <div className="page-content  d-flex align-items-center py-5">
      <Container fluid>
        <div className="mx-auto w-100" style={{ maxWidth: "1200px" }}>
          {/* LOGO */}
          <div className="text-center mb-4">
            <img
              src={sebiIcon}
              alt="SEBI Logo"
              className="img-fluid"
              style={{ maxHeight: "80px" }}
            />
          </div>

          <h5 className="fw-bold text-dark mb-2">
            Annexure-I: Risk disclosures
          </h5>

          <Card
            className=""
            style={{
              border: "2px solid #000",
              borderRadius: 0,
              backgroundColor: "#F1F4F7",
            }}
          >
            <CardHeader
              className="bg-transparent text-center py-2"
              style={{
                borderBottom: "2px solid #000",
                borderRadius: 0,
              }}
            >
              <h6 className="mb-0 fw-bold text-dark text-uppercase">
                RISK DISCLOSURES ON DERIVATIVES
              </h6>
            </CardHeader>

            <CardBody className="p-4">
              {/* List: Left Aligned by default. 'ps-3' adds slight indentation */}
              <ul className="mb-0 text-dark fw-medium ps-3">
                {disclosures.map((disclosure, index) => (
                  <li key={index} className="mb-3">
                    {disclosure.text}
                  </li>
                ))}
              </ul>
            </CardBody>
          </Card>

          <div className="mt-3 text-dark">
            <span className="fw-bold">Source:</span>
            <div className="d-flex mt-1">
              <span className="me-2">1.</span>
              <a
                href={sebiLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-underline fw-medium hover-primary-dark"
              >
                SEBI study dated January 25, 2023 on "Analysis of Profit and
                Loss of Individual Traders dealing in equity Futures and Options
                (F&O) Segment", wherein Aggregate Level findings are based on
                annual Profit/Loss incurred by individual traders in equity F&O
                during FY 2021-22.
              </a>
            </div>
          </div>

          {/* BUTTON */}
          <div className="text-center mt-5">
            <button
              className="btn btn-primary  fw-medium"
              onClick={handleContinue}
              disabled={loading || verifyLoading}
              style={{ minWidth: "250px" }}
            >
              {loading || verifyLoading ? (
                <Spinner size="sm" />
              ) : (
                "I understood, Continue"
              )}
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default RiskDisclosure;
